__turbopack_context__.v({
  "arrowIcon": "_6jxLta_arrowIcon",
  "icon": "_6jxLta_icon",
  "logo": "_6jxLta_logo",
  "logo__mfIo": "_6jxLta_logo__mfIo",
  "logo__oJ0Tf": "_6jxLta_logo__oJ0Tf",
  "logo__pKa": "_6jxLta_logo__pKa",
  "logo__qyiw0": "_6jxLta_logo__qyiw0",
  "logo__vNiYx": "_6jxLta_logo__vNiYx",
  "logo__y3Gro": "_6jxLta_logo__y3Gro",
  "logocurrentSection2_myCme__qyiw0Ikjgr": "_6jxLta_logocurrentSection2_myCme__qyiw0Ikjgr",
  "logocurrentSection2_myCme__vNiYxIkjgr": "_6jxLta_logocurrentSection2_myCme__vNiYxIkjgr",
  "logocurrentSection2_myCme__y3GroIkjgr": "_6jxLta_logocurrentSection2_myCme__y3GroIkjgr",
  "logocurrentSection2_myEvaluations__qyiw0Gqm7Z": "_6jxLta_logocurrentSection2_myEvaluations__qyiw0Gqm7Z",
  "logocurrentSection2_myEvaluations__y3GroGqm7Z": "_6jxLta_logocurrentSection2_myEvaluations__y3GroGqm7Z",
  "logocurrentSection2_myGme": "_6jxLta_logocurrentSection2_myGme",
  "logocurrentSection2_myGme__qyiw0LBvY": "_6jxLta_logocurrentSection2_myGme__qyiw0LBvY",
  "logocurrentSection2_myGme__vNiYXlBvY": "_6jxLta_logocurrentSection2_myGme__vNiYXlBvY",
  "logocurrentSection2_myGme__y3GrolBvY": "_6jxLta_logocurrentSection2_myGme__y3GrolBvY",
  "logoexpanded__mfIoYplPn": "_6jxLta_logoexpanded__mfIoYplPn",
  "logoexpanded__oJ0TfYplPn": "_6jxLta_logoexpanded__oJ0TfYplPn",
  "logoexpanded__pKaYplPn": "_6jxLta_logoexpanded__pKaYplPn",
  "logoexpanded__y3GroYplPn": "_6jxLta_logoexpanded__y3GroYplPn",
  "menu": "_6jxLta_menu",
  "menuexpanded": "_6jxLta_menuexpanded",
  "option": "_6jxLta_option",
  "option2": "_6jxLta_option2",
  "option2expanded": "_6jxLta_option2expanded",
  "option3": "_6jxLta_option3",
  "option3expanded": "_6jxLta_option3expanded",
  "optionexpanded": "_6jxLta_optionexpanded",
  "options": "_6jxLta_options",
  "optionsexpanded": "_6jxLta_optionsexpanded",
  "root": "_6jxLta_root",
  "rootexpanded": "_6jxLta_rootexpanded",
  "roundButton": "_6jxLta_roundButton",
  "roundButtonexpanded": "_6jxLta_roundButtonexpanded",
});
